import { Component, OnInit, ElementRef, ViewChild, OnDestroy, Renderer2 } from '@angular/core';
import { _ } from '~shared/utils';
import { BaseComponent } from '../../../../../components/general/base/base.component';
import { MapService } from '../../../map.service';
import * as mapboxgl from 'mapbox-gl';
import MapboxDirections from '@mapbox/mapbox-gl-directions/dist/mapbox-gl-directions';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'qm-mapbox-directions',
  templateUrl: './mapbox-directions.component.html',
  styleUrls: ['./mapbox-directions.component.scss']
})
export class MapboxDirectionsComponent extends BaseComponent implements OnInit, OnDestroy {

  @ViewChild('mapboxDirections', { static: true }) mapboxDirectionsRef: ElementRef;
  private mapboxDirections;
  public map: mapboxgl.Map;
  /**
   * Subscription to DefaultLangChange.
   */
  private langChangeSubscription: Subscription;

  constructor(private mapService: MapService,
              private translate: TranslateService,
              private renderer: Renderer2) {
    super();
    this.name = MapboxDirectionsComponent.getComponentName();
  }

  private static getComponentName(): string {
    return 'MapboxDirections';
  }

  private addDirectionsElem() {
    const originPlaceholder = this.translate.instant((_('Origin:')));
    const destinationPlaceholder = this.translate.instant((_('Destination:')));
    if (!this.map) {
      this.map = this.mapService.getMap();
    }
    this.mapboxDirections = new MapboxDirections({
      accessToken: this.mapService.getAccessToken(),
      unit: 'metric',
      interactive: false,
      profile: 'mapbox/driving-traffic',
      placeholderOrigin: originPlaceholder,
      placeholderDestination: destinationPlaceholder,
      language: this.translate.currentLang,
      geocoder: {
        language: this.translate.currentLang
      },
    });
    this.renderer.appendChild(this.mapboxDirectionsRef.nativeElement, this.mapboxDirections.onAdd(this.map));
  }

  ngOnInit() {
    console.log('onInit');
    this.addDirectionsElem();
    /**
     * If there is something ongoing in mapbox it is possible that mapbox.loaded() returns false and
     * in that case directions plugin does not add directions source to the map.
     * Calling mapState() adds directions source to the map.
    */
    if (!this.map.loaded() && !this.map.getSource('directions')) {
      this.mapboxDirections.mapState();
    }
    this.langChangeSubscription = this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.map.removeControl(this.mapboxDirections);
      this.mapboxDirections = null;
      this.addDirectionsElem();
      /**Workaround for showing origin and destination points and route on the map.
       * mapbox.loaded() returns false after map's styles or sources are changed.
       * This causes that directions plugin does not call mapState() where a new directions source
       * is added. This is a known problem - check related mapbox-gl-directions issues
       */
      this.mapboxDirections.mapState();
    });
  }

  ngOnDestroy() {
    this.map.removeControl(this.mapboxDirections);
    this.langChangeSubscription.unsubscribe();
  }

  public clearDirections() {
    this.mapboxDirections.removeRoutes();
  }

}
